<template>
  <div class="nested-list-wrapper d-flex">
    <div class="p-3 parent-list">
      <slot name="parent-list" />
    </div>
    <div class="p-3 child-list">
      <slot name="child-list" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SduiNestedLists',
  components: {},
  data: () => ({}),
  computed: {},
  methods: {},
  watch: {},
  created() {},
}
</script>

<style scoped lang="scss">
.nested-list-wrapper {
  border: 1px solid $color-gray-100;
  border-radius: 16px;

  > div {
    &:first-child {
      width: 40%;
    }

    &:last-child {
      width: 60%;
      border-left: 1px solid $color-gray-100;
    }
  }
}

@include media($mobile) {
  .nested-list-wrapper {
    display: block !important;
    border: none;

    > div {
      width: 100% !important;
      padding: 0 !important;
      border: none;
    }
  }
}
</style>
